export const GET_MY_TRANSACTIONS = "GET_MY_TRANSACTIONS";
export const SET_MY_TRANSACTIONS = "SET_MY_TRANSACTIONS";

export const GET_USERS_TRANSACTIONS = "GET_MY_TRANSACTIONS";
export const SET_USERS_TRANSACTIONS = "SET_USERS_TRANSACTIONS";